import src from "IMAGE";
export default { src, width: 2334, height: 531, blurWidth: 0, blurHeight: 0};
